import {
    HTTP,
} from '@/utils/http-common'

export default {
    create (parent, query, viz) {
        return HTTP.post(`/query/manage/${query.id}/visualization/`, viz).catch(err => {
            parent.$store.commit('push', {
                msg: `Error : ${err}`,
                color: 'error',
            })
        })
    },
    update (parent, viz) {
        return HTTP.patch(`/visualization/manage/${viz.id}/`, viz).catch(err => {
            parent.$store.commit('push', {
                msg: `Error : ${err}`,
                color: 'error',
            })
        })
    },
    delete (parent, viz) {
        return HTTP.delete(`/visualization/manage/${viz.id}/`).catch(err => {
            parent.$store.commit('push', {
                msg: `Error : ${err}`,
                color: 'error',
            })
        })
    },
}
